import React from 'react'
import CalorexLogo from '../../components/svg/commons/calorex_logo'

const Storytelling = ({_body, search}) =>{
    let data = null
    
    _body.map(item => {
        const searchBlock = search && search ? search : "PrismicSpecialDealsPageBodyStorytelling2"
        if(item.__typename === searchBlock){
          return  data = item.primary
        }else return null
    })

    const title = data.storytelling_title
    const subTitle = data.storytelling_2_description
    return( data && 
           <div className="storytelling_container">
                <div className="container_logo--calorex">
                    <CalorexLogo />
                </div>
                <div className="container_info">
                    <p className="storytelling_title"> {title.text} </p>
                    <p className="storytelling_subtitle"> {subTitle.text} </p>
                </div>
            </div>
    )
}

export default Storytelling;
